import { getProductBySku, getProductPath } from "../config/products";
import { getRangeBySlug } from "../config/ranges";

/**
 * Resolve a single /products/:segment path segment.
 * Returns { type: 'range', range } | { type: 'legacy-sku', product, canonicalPath } | { type: 'not-found' }
 */
export function resolveProductSegment(segment) {
  if (!segment) return { type: "not-found" };

  const range = getRangeBySlug(segment);
  if (range) return { type: "range", range };

  const product = getProductBySku(segment);
  if (product) {
    return {
      type: "legacy-sku",
      product,
      canonicalPath: getProductPath(product),
    };
  }

  return { type: "not-found" };
}
